import createSelectors from './createSelectors';
import Activity from '../models/Activity';

const Select = createSelectors(Activity, {});

export default Select;
